import { RangeSlider } from '../../Form/RangeSlider/index.tsx';
import { type Props } from './types.ts';

export const ReleaseYearRangeSlider = ({ ariaLabelledBy, disabled, name, onChange, value }: Props) => {
  const formatValueLabel = (val: number) => val;
  const formatAriaValueText = (val: number) => `Released in ${String(val)}`;

  const handleOnChange = (event: Event, val: number | number[], activeThumb: number) => {
    onChange(event, val, activeThumb);
  };

  return (
    <RangeSlider
      ariaLabelledBy={ariaLabelledBy}
      disabled={disabled}
      formatAriaValueText={formatAriaValueText}
      formatValueLabel={formatValueLabel}
      getAriaLabel={() => 'Select release year range'}
      marks={[
        { label: '1910', value: 1910 },
        { label: '1940', value: 1940 },
        { label: '1970', value: 1970 },
        { label: '2000', value: 2000 },
      ]}
      max={new Date().getFullYear() + 2}
      min={1900}
      name={name}
      onChange={handleOnChange}
      step={1}
      sx={{
        '.MuiSlider-markLabel': {
          color: theme => theme.palette.grey[400],
        },
        '.MuiSlider-markLabelActive': {
          color: theme => theme.palette.grey[100],
        },
        marginLeft: theme => theme.spacing(1),
        width: theme => `calc(100% - ${theme.spacing(2)})`,
      }}
      value={value}
      valueLabelDisplay="auto"
    />
  );
};
